import React from "react";
import { range } from "range";
import { getFirstIncrement } from "./helper";
interface Props {
  className?: string;
  value: number;
  min: number;
  step: number;
  maxOptions?: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}
const QuantityDropdown = ({
  className,
  value,
  min,
  step,
  maxOptions = 16,
  onChange
}: Props) => {
  const max = maxOptions * step + (min - step);
  const options = [0, ...range(getFirstIncrement(min, step), max, step), max];
  const renderOption = (option: number) => {
    let text;
    let value: string | number = option;
    switch (option) {
      case max:
        text = "Other";
        value = "other";
        break;
      case 0:
        text = "Select Quantity";
        break;
      default:
        text = option;
    }
    return <option key={option} value={value} disabled={!option} data-sentry-component="renderOption" data-sentry-source-file="index.tsx">
        {text}
      </option>;
  };
  return <select value={value} onChange={onChange} className={className} data-sentry-component="QuantityDropdown" data-sentry-source-file="index.tsx">
      {options.map(o => renderOption(o))}
    </select>;
};
export default QuantityDropdown;